import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './MeasurementHistoryListItem.module.scss';
import { MeasurementKey } from '../../Enums/MeasurementKey.enum';
import BMIMeasurementHistoryItemHeader from '../Customs/BMIMeasurementHistoryItemHeader';
import { useRemoveMeasurementHistoryItemMutation } from '../../../../graphql/graphql';
import RemoveConfirmationModal from '../../../BaseModule/Components/RemoveConfirmation/RemoveConfirmationModal';
import BMIMeasurementItemHint from '../Customs/BMIMeasurementItemHint';

interface Props {
	item: {
		id: string;
		createdAt: string;
		wizardResultItems: {
			id: string;
			key: string;
			value: {
				rawValue: string;
			};
			formattedValue: string;
			label: string;
		}[];
	};
	measurementKey: string;
	onRemove: () => void;
}

const MeasurementHistoryListItem: React.FC<Props> = ({
	item,
	measurementKey,
	onRemove,
}) => {
	const [removeItem] = useRemoveMeasurementHistoryItemMutation();
	const [isRemoveConfirmationModalOpen, setIsRemoveConfirmationModalOpen] =
		useState(false);

	const bmi = useMemo((): string | undefined => {
		return (
			item.wizardResultItems?.find(
				wizardResultItem => wizardResultItem.key === 'bmi',
			)?.value?.rawValue ?? undefined
		);
	}, [item]);

	const handleRemove = async () => {
		setIsRemoveConfirmationModalOpen(false);
		const result = await removeItem({ input: { id: item.id } });
		if ('data' in result) {
			onRemove();
		}
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				{measurementKey === MeasurementKey.BMI && bmi && (
					<BMIMeasurementHistoryItemHeader
						date={item.createdAt}
						bmi={parseFloat(bmi)}
					/>
				)}
				<div
					className={styles.remove}
					onClick={() => setIsRemoveConfirmationModalOpen(true)}
				>
					<img src='/dist/icons/red-cross.svg' alt='Red Cross' />
				</div>
				{isRemoveConfirmationModalOpen && (
					<RemoveConfirmationModal
						opened
						onClose={() => setIsRemoveConfirmationModalOpen(false)}
						onConfirm={handleRemove}
					/>
				)}
			</div>
			<div>
				{item.wizardResultItems?.map(wizardResultItem => (
					<div key={wizardResultItem.id} className={styles.item}>
						<div className={styles.label}>
							{wizardResultItem.key === 'bmi' && <BMIMeasurementItemHint />}
							{wizardResultItem.label}
						</div>
						<div className={styles.value}>
							{wizardResultItem.formattedValue}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default MeasurementHistoryListItem;
